import cbor from 'borc'

export const cborCoder = (thingName, pdo0, pdo1) => {
    let msg = []
    let msg1 = new Map();
    msg1.set(-1, 1)
    msg1.set(-3, Date.now() / 1000)
    msg1.set(0, "pdo0")
    msg1.set(4, pdo0)
    msg1.set(-2, `${thingName}:`)
    msg.push(msg1)
    let msg2 = new Map();
    msg2.set(0, "pdo1")
    msg2.set(4, pdo1)
    msg.push(msg2)
    return cbor.encode(Array.from(msg));
}